import apiClient from "../api";

/**
 * Asistencia vista por un coordinador: puede consultar cualquier grupo de su
 * sede, sin depender de que el grupo sea suyo.
 *
 * Todos estos endpoints ya existían — los usan `Grupos_coord`, `Repinscripcion`
 * y el módulo del docente. La diferencia es que ninguno exige el unicodigo de un
 * docente, que era lo que ataba el módulo original a su dueño.
 *
 * OJO con los ids: en estas listas `idcarrera` es el id del PLAN DE ESTUDIOS
 * (no el de la carrera, que viaja aparte como `idcar`), y es ese el que espera
 * `listag33` como primer parámetro.
 */
const useCoordinadorAsistenciaApi = {
  /** Todas las carreras/planes habilitados en la sede. */
  listarCarrerasDeSede(id_sede) {
    return apiClient.get(`/postulante/listarcarrera/${id_sede}`);
  },

  listarGestionActual() {
    return apiClient.get("/docente/listarGestionActual");
  },

  /**
   * Fechas de una gestión, para poder armar el calendario de clases esperadas.
   * A diferencia del resto de este archivo, es un endpoint nuevo en capas
   * (`UNICEN/modules/academico/`): responde `{ data: {...} }`, no `{ resultado }`.
   *
   * Respuesta: { data: { id_gestion, nombre, fecha_inicio, fecha_fin, ... } }
   * con las fechas en ISO o `null`.
   */
  obtenerGestion(id_gestion) {
    return apiClient.get(`/academico/gestiones/${id_gestion}`);
  },

  /**
   * Grupos de un plan de estudios en la gestión.
   * @param {number|string} id_plan     `idcarrera` de la lista de carreras.
   * @param {number|string} id_modalidad Presencial = 1 (ver MODALIDAD_PRESENCIAL).
   */
  listarGruposDeCarrera(id_plan, id_sede, id_gestion, id_modalidad) {
    return apiClient.get(
      `/planificar/listag33/${id_plan},${id_sede},${id_gestion},${id_modalidad}`
    );
  },

  /**
   * Horario del grupo. A diferencia del endpoint del docente, se identifica solo
   * por el grupo. Devuelve el día como texto en `di`, sin índice numérico:
   * pasarlo por `normalizarHorarioGrupo` antes de usarlo.
   */
  listarHorarioDeGrupo(id_grupo) {
    return apiClient.get(`/planificar/listagh/${id_grupo}`);
  },

  /** Asistencia de toda la gestión para el grupo. */
  listarAsistenciaGeneralPorGrupo(id_grupo, id_gestion, id_sede) {
    return apiClient.get(
      `/docente/asistenciaGeneralEstudiantesPorGrupo/${id_grupo},${id_gestion},${id_sede}`
    );
  },

  /** Nómina del grupo, para el reporte NOMINA. */
  listarNominaDelGrupo(id_grupo, id_gestion, id_sede) {
    return apiClient.get(
      `/docente/listarEstudianteGrupo/${id_grupo},${id_gestion},${id_sede}`
    );
  },
};

/** Único valor que usa la planificación hoy; `Grupos_coord` también lo fija. */
export const MODALIDAD_PRESENCIAL = 1;

export default useCoordinadorAsistenciaApi;
